import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import awsconfigtrainee from './aws-exports-trainee.js';
import awsconfigmanagement from './aws-exports-management.js';

// Managers live in a different Cognito pool than trainees. Amplify namespaces its
// cookie keys by app-client id, so the presence of the management client's keys in
// the shared .amopportunities.org cookie means a manager/admin is signed in — read
// that pool's session so it's usable here (e.g. visiting /search directly as an
// admin), regardless of how they navigated in. Otherwise the management session is
// invisible to the trainee-pool config and requests go out tokenless / get rejected.
// The ?mgmt=1 flag (set by the admin "Open Program Search" hand-off) is kept as an
// explicit fallback for the moment the session is first being established.
const cookies = typeof document !== 'undefined' ? document.cookie : '';
const hasManagementSession = cookies.includes(`CognitoIdentityServiceProvider.${environment.MANAGEMENT_APP_CLIENT_ID}.`);
const mgmtUrlFlag = typeof window !== 'undefined' && /[?&]mgmt=1(?:&|$)/.test(window.location.search);
Amplify.configure(hasManagementSession || mgmtUrlFlag ? awsconfigmanagement : awsconfigtrainee);

// Store Cognito tokens in a cookie scoped to the parent domain so the session is
// shared across all *.amopportunities.org subdomains (app ↔ admin SSO). Amplify
// otherwise defaults to per-origin localStorage, which breaks cross-subdomain
// navigation (e.g. the "Admin App" link). This token-provider storage is a
// singleton and survives the dynamic Amplify.configure() pool switches the
// login/forgot/reset pages perform.
(() => {
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    const domain = host.includes('amopportunities.org') ? '.amopportunities.org' : host;
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    cognitoUserPoolsTokenProvider.setKeyValueStorage(
        new CookieStorage({ domain, secure, sameSite: 'lax', expires: 30 })
    );
})();

if (environment.production) {
    enableProdMode();
}

// Used to properly register the SW
//https://stackoverflow.com/questions/50968902/angular-service-worker-swupdate-available-not-triggered

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(() => {
        if ('serviceWorker' in navigator && environment.production) {
            navigator.serviceWorker.register('ngsw-worker.js');
        }
        console.log('SW registered');
    })
    .catch((err) => console.log(err));
